(function () {
  'use strict';

  let STORAGE_KEY = 'theme_wishlist';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {}
  }

  function isInWishlist(productId) {
    let id = String(productId);
    return getWishlist().some(function (item) { return String(item.id) === id; });
  }

  function addToWishlist(product) {
    let items = getWishlist();
    let id = String(product.id);
    if (!items.some(function (i) { return String(i.id) === id; })) {
      items.push(product);
      saveWishlist(items);
    }
  }

  function removeFromWishlist(productId) {
    let id = String(productId);
    let items = getWishlist().filter(function (i) { return String(i.id) !== id; });
    saveWishlist(items);
  }

  function updateAllButtons(productId) {
    let id = String(productId);
    let inWishlist = isInWishlist(id);
    document.querySelectorAll('[data-wishlist-btn][data-product-id="' + id + '"]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', String(inWishlist));
      let title = btn.getAttribute('data-product-title') || '';
      btn.setAttribute(
        'aria-label',
        inWishlist
          ? (btn.getAttribute('data-label-remove') || 'Remove from wishlist: ' + title)
          : (btn.getAttribute('data-label-add') || 'Add to wishlist: ' + title)
      );
    });
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { id: id, inWishlist: inWishlist } }));
  }

  function syncAllButtons() {
    document.querySelectorAll('[data-wishlist-btn]').forEach(function (btn) {
      let id = String(btn.getAttribute('data-product-id'));
      let inWishlist = isInWishlist(id);
      btn.setAttribute('aria-pressed', String(inWishlist));
    });
  }

  document.addEventListener('click', function (e) {
    let btn = e.target.closest('[data-wishlist-btn]');
    if (!btn) return;

    let id = btn.getAttribute('data-product-id');
    if (!id) return;

    if (isInWishlist(id)) {
      removeFromWishlist(id);
    } else {
      addToWishlist({
        id: id,
        title: btn.getAttribute('data-product-title') || '',
        url: btn.getAttribute('data-product-url') || '',
        image: btn.getAttribute('data-product-image') || '',
        price: btn.getAttribute('data-product-price') || ''
      });
    }

    updateAllButtons(id);

    let announce = document.getElementById('sr-page-status');
    if (announce) {
      let inWishlist = isInWishlist(id);
      let title = btn.getAttribute('data-product-title') || '';
      announce.textContent = inWishlist
        ? title + ' added to wishlist'
        : title + ' removed from wishlist';
    }
  });

  function renderWishlistGrid(container) {
    let items = getWishlist();
    container.innerHTML = '';

    if (items.length === 0) {
      let empty = document.createElement('p');
      empty.className = 'wishlist-empty';
      empty.textContent = container.getAttribute('data-empty-text') || 'Your wishlist is empty.';
      container.appendChild(empty);
      return;
    }

    let grid = document.createElement('div');
    grid.className = 'wishlist-grid';
    grid.setAttribute('role', 'list');

    items.forEach(function (item) {
      let card = document.createElement('div');
      card.className = 'wishlist-item';
      card.setAttribute('role', 'listitem');

      let imgHtml = item.image
        ? '<a href="' + item.url + '" class="wishlist-item__media" tabindex="-1" aria-hidden="true"><img src="' + item.image + '" alt="" class="wishlist-item__img" loading="lazy" width="200" height="200"></a>'
        : '';

      card.innerHTML = imgHtml +
        '<div class="wishlist-item__body">' +
          '<h3 class="wishlist-item__title"><a href="' + item.url + '">' + item.title + '</a></h3>' +
          '<p class="wishlist-item__price">' + item.price + '</p>' +
          '<div class="wishlist-item__actions">' +
            '<a href="' + item.url + '" class="btn btn--primary btn--sm">' + (container.getAttribute('data-view-text') || 'View product') + '</a>' +
            '<button class="btn btn--outline btn--sm wishlist-item__remove" data-wishlist-remove="' + item.id + '" aria-label="Remove ' + item.title + ' from wishlist">' +
              (container.getAttribute('data-remove-text') || 'Remove') +
            '</button>' +
          '</div>' +
        '</div>';

      grid.appendChild(card);
    });

    container.appendChild(grid);

    container.querySelectorAll('[data-wishlist-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        let id = btn.getAttribute('data-wishlist-remove');
        removeFromWishlist(id);
        updateAllButtons(id);
        renderWishlistGrid(container);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    syncAllButtons();

    let wishlistContainers = document.querySelectorAll('[data-wishlist-grid]');
    wishlistContainers.forEach(function (container) {
      renderWishlistGrid(container);
    });
  });

  document.addEventListener('wishlist:updated', function () {
    let wishlistContainers = document.querySelectorAll('[data-wishlist-grid]');
    wishlistContainers.forEach(function (container) {
      renderWishlistGrid(container);
    });
  });

  window.Wishlist = {
    get: getWishlist,
    add: addToWishlist,
    remove: removeFromWishlist,
    isIn: isInWishlist,
    count: function () { return getWishlist().length; }
  };
})();
